"use client";

import dynamic from "next/dynamic";

const AISpeechClassifier = dynamic(() => import("./AISpeechClassifier"));

export default AISpeechClassifier;
